export type PinpadFormState = {
  pinpadId: string;
  label: string;
  isActive: boolean;
};

export type TerminalFormState = {
  tenantId: string;
  name: string;
  terminalNumber: string;
  terminalPassword: string;
  currencyType: string;
  isActive: boolean;
  pinpads: PinpadFormState[];
};

export type TerminalCompanyChoice = {
  tenantId: string;
  companyName: string;
  isActive: boolean;
};

export const INITIAL_PINPAD: PinpadFormState = {
  pinpadId: '',
  label: '',
  isActive: true,
};

export const INITIAL_TERMINAL_FORM: TerminalFormState = {
  tenantId: '',
  name: '',
  terminalNumber: '',
  terminalPassword: '',
  currencyType: '1',
  isActive: true,
  pinpads: [{ ...INITIAL_PINPAD }],
};
